export default __webpack_public_path__ + "img/gCKudhii.ac057d67.svg";